import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, "Welche Teile des Fragebogens wollen Sie beantworten?", -1)
const _hoisted_2 = { class: "questionnaire-list" }
const _hoisted_3 = { class: "row-level2" }
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "progress-container" }

import {useStore} from "vuex";
import AppActivity from "@/components/AppActivity.vue";

import {ICON_CANCEL, ICON_OK} from "@/lib/icons";
import {useRoute, useRouter} from "vue-router";
import QuestionnaireEntity from "@/db/QuestionnaireEntity";
import getDb from "@/db/Database";
import QuestionnaireRelease from "@/api/types/QuestionnaireRelease";
import UserQuestionnaire from "@/api/types/UserQuestionnaire";
import QuestionnaireCategoryEntity from "@/db/QuestionnaireCategoryEntity";
import {ref} from "vue";
import QuestionnaireCategory from "@/api/types/QuestionnaireCategory";
import {hideSpinner, showSpinner} from "@/store";
import UserQuestionnaireCategoryEntity from "@/db/UserQuestionnaireCategoryEntity";
import UserQuestionnaireCategory from "@/api/types/UserQuestionnaireCategory";

type CategoryEntry = QuestionnaireCategory & {
  userCategory: UserQuestionnaireCategory
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFilterActivity',
  setup(__props) {

const icons = [
  ICON_OK,
  ICON_CANCEL
]

const store = useStore()
const router = useRouter()
const route = useRoute()

const mode: string = <string>route.params.mode

const allCategories = ref<CategoryEntry[]>([])

const userQuestionnaire: UserQuestionnaire = store.state.currentQuestionnaire
const release: QuestionnaireRelease = store.state.currentRelease

const checkStatus = ref<{ [id: number]: boolean }>({})

const onIconClick = async (icon: string) => {
  switch (icon) {
    case ICON_OK:
      const selectedCategories = Object.keys(checkStatus.value)
          .filter((id: any) => !!checkStatus.value[id])
          .map((id: any): number => parseInt(id))

      store.commit('check/SET_CATEGORIES', selectedCategories)
      await router.push({ name: 'check' })
      break
    case ICON_CANCEL:
      store.commit('SET_QUESTIONNAIRE', { questionnaire: null, release: null })
      await router.push({ name: 'questionnaire' })
      break
  }
}

const load = async () => {
  showSpinner()
  const questionnaire = await QuestionnaireEntity.find(getDb(), release.questionnaireId)
  if (questionnaire) {
    const categories = await QuestionnaireCategoryEntity.findAllByQuestionnaire(getDb(), questionnaire.id)
    if (categories) {
      categories.sort((a, b) => <string>a.name > <string>b.name ? 1 : -1)

      // @ts-ignore
      allCategories.value = await Promise.all(categories.map(async (category) => {
        const userCategory = await UserQuestionnaireCategoryEntity.findByCategoryId(getDb(), <number>userQuestionnaire.pk, category.id)
        if (typeof checkStatus.value[category.id] === 'undefined') {
          checkStatus.value[category.id] = !userCategory || userCategory.progress < 100
        }
        return {
          ...category,
          userCategory,
        }
      }))
    }
  }
  hideSpinner()
}

if (!userQuestionnaire || !release) {
  router.push({ name: 'questionnaire' })
} else {
  load()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    id: "category-filter-activity",
    icons: icons,
    onIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allCategories.value, (category) => {
          return (_openBlock(), _createElementBlock("li", {
            key: category.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: category.id,
                  "onUpdate:modelValue": ($event: any) => ((checkStatus.value[category.id]) = $event)
                }, null, 8, _hoisted_5), [
                  [_vModelCheckbox, checkStatus.value[category.id]]
                ])
              ]),
              _createElementVNode("label", {
                for: category.id,
                class: "name"
              }, _toDisplayString(category.name), 9, _hoisted_6),
              _createElementVNode("div", _hoisted_7, _toDisplayString(category.userCategory?.progress || 0) + "%", 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})